import React from 'react';
import PermissionAccounts from '../permissions/accounts';
export default function RolesScreen() { return <PermissionAccounts kind="role" />; }
